import script from "./LiuNianTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LiuNianTable.vue?vue&type=script&setup=true&lang=js"

import "./LiuNianTable.vue?vue&type=style&index=0&id=3fd30598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd30598"]])

export default __exports__